import {hasAllPermissions, hasAnyPermission, hasPermission, isAnyFeatureEnabled, isFeatureEnabled} from "../helpers/permissions";
import GenericHelpers from "../helpers/generic-helpers";
import store from "../store";


const viewPort = GenericHelpers.getViewport()

export default [
    {
        title: 'omt.gui.menu.label.dashboard',
        show: () => hasPermission('metabase.view'),
    },
    {
        to: {name: 'dashboard'},
        title: 'omt.gui.menu.label.home',
        icon: 'pe-7s-display2',
        show: () => hasPermission('metabase.view'),
    },
    {
        title: 'omt.gui.menu.label.orders',
        show: () => true,
    },
    {
        to: {name: 'FrontendFilterOrderSearch'},
        title: 'omt.gui.menu.label.search',
        icon: 'pe-7s-search',
        show: () => hasPermission('frontend.search.default') && hasAnyPermission(['orders.view', 'orders.pickbystore.process']),
    },
    {
        to: {name: 'FrontendFilterOrderSearchHoldOrders'},
        title: 'omt.gui.menu.label.hold-orders',
        icon: 'pe-7s-drawer',
        show: () => isFeatureEnabled('hold-orders') && hasPermission('orders.holdreview.view'),
    },
    {
      to: {name: 'orderListImportErrors'},
      title: 'omt.gui.menu.label.orders-import-errors',
      icon: 'pe-7s-attention',
      show: () => isFeatureEnabled('import-errors') && hasPermission('orders.importerrors.view'),
      class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'FrontendFilterOrderSearchReturnOrders'},
        title: 'omt.gui.menu.label.return-orders',
        icon: 'pe-7s-back-2',
        show: () => isFeatureEnabled('return-orders') && hasAllPermissions(['orders.returnorders.view', 'orders.view']),
    },
    {
        to: {name: 'FrontendFilterOrderSearchFallbackOrders'},
        title: 'omt.gui.menu.label.fallback-orders',
        icon: 'pe-7s-help2',
        show: () => isFeatureEnabled('fallback-orders') && hasAllPermissions(['orders.importerrors.view', 'orders.view']),
    },
    {
        to: {name: 'FrontendFilterOrderSearchPickByStore'},
        title: 'omt.gui.menu.label.pick-by-store',
        icon: 'pe-7s-cart',
        show: () => isFeatureEnabled('pick-by-store') && hasPermission('orders.pickbystore.process'),
    },
    {
        to: {name: 'PresaleListIncomplete'},
        title: 'omt.gui.menu.label.presales',
        icon: 'pe-7s-hourglass',
        show: () => isFeatureEnabled('presales') && hasPermission('presaleschedules.view'),
    },
    {
        to: {name: 'FrontendFilterOrderSearchRequiresNextActionDecision'},
        title: 'omt.gui.menu.label.requires-next-action-decision',
        icon: 'pe-7s-way',
        show: () => isFeatureEnabled('dispatch-request-next-action-decisions') && hasPermission('orders.dispatchrequests.nextaction.decision'),
    },

    /**************************/

    {
        title: 'omt.gui.menu.label.processing',
        show: () => isAnyFeatureEnabled(['refunds', 'batching']) &&
                    hasAnyPermission   (['refunds.view', 'orders.batch.process',
                                         'orders.batch.index', 'orders.batch.process.return']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'FrontendFilterOrderSearchRefundOrders'},
        title: 'omt.gui.menu.label.refunds',
        icon: 'pe-7s-cash',
        show: () => isFeatureEnabled('refunds') && hasPermission('refunds.view'),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'ShipmentBatchesIndex'},
        title: 'omt.gui.menu.label.batches',
        icon: 'pe-7s-box2',
        show: () => isFeatureEnabled('batching') && hasAllPermissions('orders.batch.process.sort', 'orders.batch.index'),
    },
    {
        to: store.getters.getLocationsForUser
            .then(() => {
                return {
                    name: 'ProcessStartWithoutBatch',
                    params: {
                        locationTypeIdentifier: store.state.locationsForUser[0]?.location_type.identifier,
                        locationIdentifier: store.state.locationsForUser[0]?.identifier,
                        processType: 'return',
                    },
                }
            }),
        title: 'omt.gui.menu.label.scan-return-orders-current-location',
        icon: 'pe-7s-box2',
        show: () => store.getters.getLocationsForUser
            .then(() => {
                return store.state.locationsForUser.length === 1 && isFeatureEnabled('return-orders') && hasPermission('orders.batch.process.return')
            })
    },

    /**************************/

    {
        title: 'omt.gui.menu.label.other',
        show: () => isAnyFeatureEnabled(['goods-receipt', 'locations']) && hasAnyPermission(['locations.contactinfo.view', 'stockmanagement.view', 'goodsreceipt.view']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'FrontendFilterLocationSearch'},
        matchRouteNames: ['FrontendFilterLocationSearch'],
        title: 'omt.gui.menu.label.location-management',
        icon: 'pe-7s-global',
        show: () => isFeatureEnabled('locations') && hasAllPermissions('locations.contactinfo.view'),
    },
    {
        to: {name: 'QuickSuggestion'},
        title: 'omt.gui.menu.label.quick-suggestion',
        icon: 'pe-7s-compass',
        show: () => hasPermission('sle.quicksuggestion'),
    },
    {
        to: {name: 'StockManagement'},
        title: 'omt.gui.menu.label.stock-management',
        icon: 'pe-7s-note2',
        show: () => isFeatureEnabled('stock-management') && hasAnyPermission(['stockmanagement.view']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'SupplyChainManagement'},
        title: 'omt.gui.menu.label.supply-chain-management',
        icon: 'pe-7s-link',
        show: () => isFeatureEnabled('supply-chain-management') && hasAnyPermission(['sle.supplychains.admin']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: store.getters.getLocationsForUser
            .then(() => {
                return {
                    name: 'GoodsReceiptIndex',
                    params: {
                        locationTypeIdentifier: store.state.locationsForUser[0]?.location_type.identifier,
                        locationIdentifier:     store.state.locationsForUser[0]?.identifier,
                    },
                }
            }),
        title: 'omt.gui.menu.label.goods-receipts',
        icon: 'pe-7s-download',
        show: () => store.getters.getLocationsForUser
            .then(() => {
                return store.state.locationsForUser.length === 1 && isFeatureEnabled('goods-receipt') && hasPermission('goodsreceipt.view')
            })
    },

    /**************************/

    {
        title: 'omt.gui.menu.label.settings',
        show: () => isFeatureEnabled('hold-orders') && hasAnyPermission(['holdrules.view', 'triggers.edit', 'appsettings.edit', 'appsettings.view', 'locations.appsettings', 'processormanager.view']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: {name: 'holdRuleGroups'},
        title: 'omt.gui.menu.label.hold-rules',
        icon: 'pe-7s-flag',
        show: () => isFeatureEnabled('hold-orders') && hasPermission('holdrules.view'),
        class: {'d-none d-lg-flex': true},
    },

    {
        to: {
            name: 'settings',
        },
        title: 'omt.gui.menu.label.settings-app',
        icon: 'pe-7s-config',
        show: () => hasAnyPermission(['appsettings.edit', 'appsettings.view']),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: store.getters.getLocationsForUser
            .then(() => {
                return {
                    name: 'omt.gui.menu.label.app-settings',
                    params: {
                        locationTypeIdentifier: store.state.locationsForUser[0]?.location_type.identifier,
                        locationIdentifier: store.state.locationsForUser[0]?.identifier,
                    },
                }
            }),
        title: 'omt.gui.menu.label.app-settings-current-location',
        icon: 'pe-7s-settings',
        show: () => store.getters.getLocationsForUser
            .then(() => {
                return store.state.locationsForUser.length === 1 && isFeatureEnabled('locations') && hasPermission('locations.appsettings')
            }),
        class: {'d-none d-lg-flex': true},
    },
    {
        to: '/psm/gui/psm_visual',
        title: 'omt.gui.menu.label.processormanager-view',
        icon: 'pe-7s-map',
        show: () => store.state.config['menu-items']['psm'] && hasAnyPermission(['processormanager.view']),
        class: {'d-none d-lg-flex': true},
        target: "_blank",
    },
    {
        to: '/docs/',
        title: 'omt.gui.menu.label.api-documentation-view',
        icon: 'pe-7s-map',
        show: () => store.state.config['menu-items']['docs'] && hasAnyPermission(['documentation.api.view']),
        class: {'d-none d-lg-flex': true},
        target: "_blank",
    },
    {
        to: '/box-suggestion-service-docs/docs',
        title: 'omt.gui.menu.label.box-suggestion-service-docs-view',
        icon: 'pe-7s-map',
        show: () => store.state.config['menu-items']['box-suggestion-service-docs'] && hasAnyPermission(['documentation.api.view']),
        class: {'d-none d-lg-flex': true},
        target: "_blank",
    },
    {
        title: 'OmniPortal',
        show: () => true,
        class: {'d-flex d-lg-none': true},
    },
    {
        to: store.getters.getOmniPortalBaseURL,
        title: 'OmniPortal',
        icon: 'pe-7s-angle-left',
        show: () => true,
        class: {'d-flex d-lg-none': true},
    },
]
